@let legalDocuments = legalDocumentsFiles.value();
<div class="footer-text no-print">
    ©{{ Temporal.Now.plainDateISO().year }}
    @if (isNotCustomBranding()) {
        Advizeo
    }
    |
    <a target="_blank" [href]="legalDocuments?.generalConditionUrl">{{ 'GENERAL_CONDITIONS.FOOTER.CGU_LABEL' | translate }}</a>
    |
    <a target="_blank" [href]="legalDocuments?.privacyPolicyUrl">{{ 'GENERAL_CONDITIONS.FOOTER.PRIVACY_LABEL' | translate }}</a>
    |
    <a target="_blank" [href]="legalDocuments?.cookiePolicyUrl">{{ 'GENERAL_CONDITIONS.FOOTER.COOKIES_LABEL' | translate }}</a>
    |
    <a target="_blank" [href]="legalDocuments?.accessibilityUrl">{{ 'GENERAL_CONDITIONS.FOOTER.ACCESIBILITY_LABEL' | translate }}</a>
</div>
